// Name for an instant webhook: the first line of what the user typed (trimmed
// to a few words), else a random "webhook-1234".
export function webhookName(text: string, rand: () => number = Math.random): string {
  const line = text.split('\n').map((l) => l.trim()).find((l) => l !== '') ?? '';
  const words = line.replace(/[^\p{L}\p{N}\s._-]/gu, ' ').split(/\s+/).filter(Boolean).slice(0, 5).join(' ').slice(0, 40).trim();
  return words || `webhook-${1000 + Math.floor(rand() * 9000)}`;
}
